/**
 * `useCan(permission, feature?)`: the SPA side of the single decision function. It calls
 * `can()` from @oex/auth, i.e. the same `authorize()` the API's PolicyGuard runs, on the Actor
 * built from `/v1/me`. `allowed` → show; `locked` (role ok, plan not) → lock + upsell;
 * `hidden` (role forbids) → render nothing (docs/09 "Navigation discovery").
 */
import { can, type CanResult, type Permission, type PlatformPermission } from '@oex/auth';
import { useSession } from './session';

export function useCan(permission: Permission | PlatformPermission, feature?: string): CanResult {
  const { actor } = useSession();
  return can(actor, permission, feature);
}
